module.exports = __webpack_public_path__ + "img/calendar-plus-01.465dac18.svg";